import Wrapper from '../assets/wrappers/JobInfo'

const InformationItemInfo = ({ icon, text, headline }) => {
    text = text.replace(".",",").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    return (
        <Wrapper>
            <span className='icon'>{icon}</span>
            <span className={headline ? "text headline" : "text"}><p>{text}</p></span>
        </Wrapper>
    )
}

export default InformationItemInfo;